import { render } from "./Loading.vue?vue&type=template&id=41561d42&scoped=true"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

import "./Loading.vue?vue&type=style&index=0&id=41561d42&scoped=true&lang=scss"

import exportComponent from "/opt/tracking-bg-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41561d42"]])

export default __exports__